import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "actions-col d-flex" }
const _hoisted_2 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_base_card = _resolveComponent("base-card")!
  const _component_gain_configuration_versions_modal = _resolveComponent("gain-configuration-versions-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_base_card, {
      "no-header": "",
      class: "width-100"
    }, {
      body: _withCtx(() => [
        _createVNode(_component_el_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 5 }, {
              default: _withCtx(() => [
                _createElementVNode("h3", null, _toDisplayString($setup.form.configurationName), 1),
                _createElementVNode("h3", {
                  class: "body-1 cursor-pointer mt-1",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.openVersionModal && $setup.openVersionModal(...args)))
                }, _toDisplayString(_ctx.$t('currentVersion') + ': ' + $props.configuration.version), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 15 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form, {
                  ref: "formRef",
                  model: $setup.form,
                  rules: $setup.formRules
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      class: "mb-0",
                      label: _ctx.$t('fileNameWithoutExtension'),
                      prop: "outputFileName"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: $setup.form.outputFileName,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.form.outputFileName) = $event)),
                          size: "small",
                          onChange: $setup.emitUpdate
                        }, null, 8, ["modelValue", "onChange"])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_el_form_item, {
                      label: _ctx.$t('apiConnectionName'),
                      class: "mb-0",
                      prop: "apiConnectionName"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_tooltip, {
                          disabled: 
                  $setup.props.apiConnections.find(
                    c => Number(c.apiName) === Number($setup.form.apiConnectionName)
                  )?.enabled
                ,
                          placement: "top",
                          content: _ctx.$t('disabledApiConnectionNoDataFetched')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              modelValue: $setup.form.apiConnectionName,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.form.apiConnectionName) = $event)),
                              disabled: "",
                              size: "small",
                              filterable: "",
                              onChange: $setup.emitUpdate
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.apiNameOptions, (opt) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: opt.value,
                                    label: opt.label,
                                    value: opt.value
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "onChange"])
                          ]),
                          _: 1
                        }, 8, ["disabled", "content"])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_el_form_item, {
                      label: _ctx.$t('executionTrigger'),
                      class: "mb-0",
                      prop: "executionTrigger"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: $setup.form.executionTrigger,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.form.executionTrigger) = $event)),
                          disabled: "",
                          size: "small",
                          filterable: "",
                          onChange: $setup.emitUpdate
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys($setup.ExecutionTrigger), (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item,
                                label: _ctx.$t(item),
                                value: $setup.ExecutionTrigger[item]
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "onChange"])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_el_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_col, { span: 8 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_form_item, {
                              label: _ctx.$t('numberOfRetries'),
                              prop: "numberOfRetries"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input_number, {
                                  modelValue: $setup.form.numberOfRetries,
                                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.form.numberOfRetries) = $event)),
                                  min: 0,
                                  max: 20,
                                  onChange: $setup.emitUpdate
                                }, null, 8, ["modelValue", "onChange"])
                              ]),
                              _: 1
                            }, 8, ["label"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_col, { span: 8 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_form_item, {
                              label: _ctx.$t('retryDelayMilliseconds'),
                              prop: "retryDelay"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input_number, {
                                  modelValue: $setup.form.retryDelay,
                                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.form.retryDelay) = $event)),
                                  min: 0,
                                  max: 30000,
                                  step: 100,
                                  onChange: $setup.emitUpdate
                                }, null, 8, ["modelValue", "onChange"])
                              ]),
                              _: 1
                            }, 8, ["label"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_divider, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('midBatchSettings')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: _ctx.$t('sqlNodeName'),
                      class: "mb-0",
                      prop: "sqlNodeName"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_tooltip, {
                          placement: "top",
                          content: _ctx.$t('sqlNodeNameTooltip')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              modelValue: $setup.form.sqlNodeName,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.form.sqlNodeName) = $event)),
                              size: "small",
                              filterable: "",
                              onChange: $setup.emitUpdate
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.props.sqlNodes, (node) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: node.name ?? '',
                                    label: node.name ?? '',
                                    value: node.name ?? ''
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "onChange"])
                          ]),
                          _: 1
                        }, 8, ["content"])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_el_form_item, {
                      label: _ctx.$t('targetTableName'),
                      class: "mb-0",
                      prop: "targetTableName"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: $setup.form.targetTableName,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.form.targetTableName) = $event)),
                          size: "small",
                          onChange: $setup.emitUpdate
                        }, null, 8, ["modelValue", "onChange"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _: 1
                }, 8, ["model", "rules"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              span: 4,
              class: "actions-col-wrapper d-flex"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  (!$props.disableDeleteAndSave)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: require(`@/assets/images/icons/new/delete.svg`),
                        height: "20",
                        width: "20",
                        class: "action-icon cursor-pointer",
                        onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => ($setup.deleteApiFileConfiguration && $setup.deleteApiFileConfiguration(...args)))
                      }, null, 8, _hoisted_2))
                    : _createCommentVNode("", true),
                  (!$props.disableDeleteAndSave)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 1,
                        type: "primary",
                        size: "large",
                        onClick: $setup.saveItem
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('save')), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_gain_configuration_versions_modal, {
      modelValue: $setup.showVersionModal,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.showVersionModal) = $event)),
      "configuration-versions": $setup.props.configurationHistory,
      onRestore: $setup.handleRestore,
      onClose: _cache[10] || (_cache[10] = ($event: any) => ($setup.showVersionModal = false))
    }, null, 8, ["modelValue", "configuration-versions", "onRestore"])
  ], 64))
}